// Admin workspace mutations: block / unblock.
//
// Invalidation follows the shared admin pattern: invalidate the admin root,
// then refetch active queries so the open page reflects the change at once.
import { useMutation } from '@tanstack/react-query';

import { queryClient } from '../../../shared/query/queryClient.js';

import {
  ADMIN_QUERY_ROOT,
  blockAdminWorkspace,
  unblockAdminWorkspace,
} from '../api/admin.client.js';

async function invalidateAdminQueries(): Promise<void> {
  await queryClient.invalidateQueries({ queryKey: [ADMIN_QUERY_ROOT] });
  await queryClient.refetchQueries({ queryKey: [ADMIN_QUERY_ROOT], type: 'active' });
}

export function useAdminWorkspacesMutations() {
  const blockMutation = useMutation({
    mutationFn: (input: { workspaceId: string; reason?: string }) =>
      blockAdminWorkspace(input.workspaceId, input.reason),
    onSuccess: invalidateAdminQueries,
  });

  const unblockMutation = useMutation({
    mutationFn: (workspaceId: string) => unblockAdminWorkspace(workspaceId),
    onSuccess: invalidateAdminQueries,
  });

  return { blockMutation, unblockMutation };
}
